<script>
  /* global Global */
  import AdminAction from '../ui-components/AdminAction.svelte';
  import ColorStripe from '../ui-components/ColorStripe.svelte';
  import Title from '../js/title.js';

  export let img = 'title/title.jpg';
  export let alt = 'Title photo';
  export let title = undefined;
  export let subtitle = undefined;
  export let color = undefined;
  export let home = false;
  export let lang = undefined;
  export let user;

  const i18n = {
    edit: {
      cs: 'Upravit',
      en: 'Edit',
    },
  };

  const projectCode = Global.project.code;
  const projectStyle = Global.project.style;
</script>

<div class='title' class:title-old={projectStyle === 'old'}>
  {#if !home}
    {#await Title.getTimestamps() then timestamps}
      {@const match = img.match(/^title\/(.*)\.jpg$/)}

      {#if match && timestamps[match[1]]}
        <img class='title-image' src='img/{img}?t={timestamps[match[1]]}' alt={alt}/>
      {:else}
        <img class='title-image' src='img/{img}' alt={alt}/>
      {/if}
    {/await}

    {#if user?.roles.includes('ROLE_ADMIN')}
      <div class='title-admin'>
        <div class='title-admin-content'>
          <AdminAction value={i18n.edit[lang]} icon='edit'
            onClick={() => { window.location.href = `./#/admin/title/${img.match(/^title\/(.*)\.jpg$/)[1]}`; }}/>
        </div>
      </div>
    {/if}
  {:else}
    {#await Title.getTimestamps() then timestamps}
      <img class='title-image title-image-a' src='img/title/title-1.jpg?t={timestamps['title-1']}' alt={alt}/>
      <img class='title-image title-image-b' src='img/title/title-2.jpg?t={timestamps['title-2']}' alt={alt}/>
      <img class='title-image title-image-c' src='img/title/title-3.jpg?t={timestamps['title-3']}' alt={alt}/>
      <img class='title-image title-image-d' src='img/title/title-4.jpg?t={timestamps['title-4']}' alt={alt}/>
      <img class='title-image title-image-e' src='img/title/title-5.jpg?t={timestamps['title-5']}' alt={alt}/>
      <img class='title-image title-image-f' src='img/title/title-1.jpg?t={timestamps['title-1']}' alt={alt}/>
    {/await}

    {#if user?.roles.includes('ROLE_ADMIN')}
      <div class='title-admin title-admin-x'>
        <div class='title-admin-content'>
          <AdminAction value={`${i18n.edit[lang]} [1]`} icon='edit'
            onClick={() => { window.location.href = './#/admin/title/title-1'; }}/>

          <AdminAction value={`${i18n.edit[lang]} [2]`} icon='edit'
            onClick={() => { window.location.href = './#/admin/title/title-2'; }}/>

          <AdminAction value={`${i18n.edit[lang]} [3]`} icon='edit'
            onClick={() => { window.location.href = './#/admin/title/title-3'; }}/>

          <AdminAction value={`${i18n.edit[lang]} [4]`} icon='edit'
            onClick={() => { window.location.href = './#/admin/title/title-4'; }}/>

          <AdminAction value={`${i18n.edit[lang]} [5]`} icon='edit'
            onClick={() => { window.location.href = './#/admin/title/title-5'; }}/>
        </div>
      </div>
    {/if}
  {/if}

  <div class='title-text'>
    <div class='title-text-content'>
      {#if title}
        <div class='title-text-content-title'
          class:title-text-content-title-red={color === 'red'}
          class:title-text-content-title-yellow={color === 'yellow'}
          class:title-text-content-title-green={color === 'green'}
          class:title-text-content-title-blue={color === 'blue'}
          class:title-text-content-title-purple={color === 'purple'}>

          {title}
        </div>
      {:else}
        <div class='title-text-content-logo'>
          {#if projectCode === 'pbw'}
            <img class='title-text-content-logo-image' src='img/static/logo-pbw.svg' alt='Prague Baseball Week logo'/>
          {:else}
            <img class='title-text-content-logo-image' src='img/static/logo.svg' alt='Eurobaseball 2023 logo'/>
          {/if}
        </div>
      {/if}

      {#if subtitle}
        <div class='title-text-content-subtitle'>
          {subtitle}
        </div>
      {/if}
    </div>
  </div>

  {#if projectCode === 'pbw'}
    <img class='title-graphic' src='img/static/graphic/title.svg' alt='Prague Baseball Week title graphic'/>
  {/if}

  <div class='title-color-stripe'>
    <ColorStripe/>
  </div>
</div>

<style>
  .title {
    position: relative;

    height: calc(70vh - 60px);
  }

  .title-image {
    position: absolute;
    top: 0px;

    width: 100%;
    height: calc(100% - 5px);

    object-fit: cover;
    object-position: center 20%;

    filter: brightness(90%);
  }

  .title-image-a, .title-image-b, .title-image-c,
  .title-image-d, .title-image-e, .title-image-f {
    opacity: 0;

    object-position: center 20%;

    animation-duration: 60s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
  }

  .title-image-a { animation-name: titleImageA; }
  .title-image-b { animation-name: titleImageB; }
  .title-image-c { animation-name: titleImageC; }
  .title-image-d { animation-name: titleImageD; }
  .title-image-e { animation-name: titleImageE; }
  .title-image-f { animation-name: titleImageF; }

  @keyframes titleImageA {
    0% { opacity: 1; }
    10% { opacity: 1; }
    22% { opacity: 0; }
    100% { opacity: 0; }
  }

  @keyframes titleImageB {
    8% { opacity: 0; }
    10% { opacity: 1; }
    30% { opacity: 1; }
    32% { opacity: 0; }
  }

  @keyframes titleImageC {
    28% { opacity: 0; }
    30% { opacity: 1; }
    50% { opacity: 1; }
    52% { opacity: 0; }
  }

  @keyframes titleImageD {
    48% { opacity: 0; }
    50% { opacity: 1; }
    70% { opacity: 1; }
    72% { opacity: 0; }
  }

  @keyframes titleImageE {
    68% { opacity: 0; }
    70% { opacity: 1; }
    90% { opacity: 1; }
    92% { opacity: 0; }
  }

  @keyframes titleImageF {
    0% { opacity: 0; }
    88% { opacity: 0; }
    90% { opacity: 1; }
    100% { opacity: 1; }
  }

  .title-admin {
    position: absolute;

    width: calc(100% - 120px);
    height: calc(100% - 120px);

    padding: 60px;
  }

  .title-admin-content {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    gap: 10px;

    width: 100%;
    height: 100%;
    max-width: 1450px;

    margin: auto;
  }

  .title-text {
    position: absolute;

    width: calc(100% - 120px);
    height: calc(100% - 120px);

    padding: 60px;

    font-family: var(--font-secondary);
    font-weight: bold;

    pointer-events: none;
  }

  .title-text-content {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    gap: 30px;

    width: 100%;
    height: 100%;
    max-width: 1450px;

    margin: auto;
  }

  .title-text-content-title {
    max-width: fit-content;

    padding: 20px 40px;

    font-size: 48px;

    background: var(--primary);
    color: var(--white);
  }

  .title-text-content-logo {
    display: flex;
    align-items: flex-end;
    flex-grow: 1;

    width: 100%;
    height: 0px;
    max-width: 550px;
  }

  .title-text-content-logo-image {
    max-width: 100%;
    max-height: 100%;

    padding: 7.5%;

    box-sizing: border-box;

    background: var(--primary);
  }

  .title-text-content-subtitle {
    max-width: fit-content;

    padding: 10px 20px;

    font-size: 32px;

    background: var(--white);
  }

  .title-graphic {
    position: absolute;
    bottom: 5px;
    right: 0px;

    height: 60px;
    max-width: 50%;

    object-fit: cover;
    object-position: left;
  }

  .title-color-stripe {
    position: absolute;
    bottom: 0px;

    width: 100%;
  }

  .title-text-content-title-red {
    background: linear-gradient(135deg, var(--red), var(--dark-red));
  }

  .title-old .title-text-content-title-red {
    background: var(--secondary);
  }

  .title-text-content-title-yellow {
    background: linear-gradient(135deg, var(--yellow), var(--orange));
  }

  .title-old .title-text-content-title-yellow {
    background: var(--secondary);
  }

  .title-text-content-title-green {
    background: linear-gradient(135deg, var(--green), var(--dark-green));
  }

  .title-old .title-text-content-title-green {
    background: var(--secondary);
  }

  .title-text-content-title-blue {
    background: linear-gradient(135deg, var(--blue), var(--dark-blue));
  }

  .title-old .title-text-content-title-blue {
    background: var(--secondary);
  }

  .title-text-content-title-purple {
    background: linear-gradient(135deg, var(--purple), var(--turquoise));
  }

  .title-old .title-text-content-title-purple {
    background: var(--secondary);
  }

  :global(body.dark) .title-image {
    filter: brightness(80%);
  }

  :global(body.dark) .title-text-content-title {
    background: var(--primary-dark);
    color: var(--grey-3);
  }

  :global(body.dark) .title-text-content-logo-image {
    filter: brightness(88%);
  }

  :global(body.dark) .title-text-content-subtitle {
    background: var(--grey-3);
    color: var(--black);
  }

  :global(body.dark) .title-graphic {
    filter: brightness(88%);
  }

  :global(body.dark) .title-text-content-title-red {
    background: linear-gradient(135deg, var(--red-dark), var(--dark-red-dark));
  }

  :global(body.dark) .title-old .title-text-content-title-red {
    background: var(--secondary-dark);
  }

  :global(body.dark) .title-text-content-title-yellow {
    background: linear-gradient(135deg, var(--yellow-dark), var(--orange-dark));
  }

  :global(body.dark) .title-old .title-text-content-title-yellow {
    background: var(--secondary-dark);
  }

  :global(body.dark) .title-text-content-title-green {
    background: linear-gradient(135deg, var(--green-dark), var(--dark-green-dark));
  }

  :global(body.dark) .title-old .title-text-content-title-green {
    background: var(--secondary-dark);
  }

  :global(body.dark) .title-text-content-title-blue {
    background: linear-gradient(135deg, var(--blue-dark), var(--dark-blue-dark));
  }

  :global(body.dark) .title-old .title-text-content-title-blue {
    background: var(--secondary-dark);
  }

  :global(body.dark) .title-text-content-title-purple {
    background: linear-gradient(135deg, var(--purple-dark), var(--turquoise-dark));
  }

  :global(body.dark) .title-old .title-text-content-title-purple {
    background: var(--secondary-dark);
  }

  @media only screen and (max-width: 900px) {
    .title-admin {
      width: calc(100% - 80px);
      height: calc(100% - 80px);

      padding: 40px;
    }

    .title-text {
      width: calc(100% - 80px);
      height: calc(100% - 80px);

      padding: 40px;
    }

    .title-text-content {
      gap: 20px;
    }

    .title-text-content-title {
      font-size: 32px;
    }

    .title-text-content-subtitle {
      font-size: 24px;
    }

    .title-graphic {
      height: 40px;
    }
  }

  @media only screen and (max-width: 850px) {
    .title-admin-x {
      display: none;
    }
  }

  @media only screen and (max-width: 400px) {
    .title-text-content-title {
      font-size: 24px;
    }

    .title-text-content-subtitle {
      font-size: 16px;
    }
  }

  @media only screen and (max-width: 350px) {
    .title-text {
      width: calc(100% - 40px);
      height: calc(100% - 40px);

      padding: 20px;
    }

    .title-text-content {
      gap: 10px;
    }

    .title-graphic {
      display: none;
    }
  }
</style>
